import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Separator } from './ui/separator';
import { Phone, Mail, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import { mockData } from '../mockData';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src={mockData.companyInfo.logo} 
              alt="OL-CONSULT" 
              className="h-16 w-16 object-contain bg-white rounded-lg p-2"
            />
            <h3 className="text-xl font-bold">{mockData.companyInfo.name}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.companyDesc')}
            </p>
            <div className="flex space-x-3 pt-2">
              <a href="#" className="p-2 bg-gray-800 rounded-lg hover:bg-blue-900 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-gray-800 rounded-lg hover:bg-blue-900 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-gray-800 rounded-lg hover:bg-blue-900 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/" className="hover:text-white transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">{t('nav.services')}</Link></li>
              <li><Link to="/business-areas" className="hover:text-white transition-colors">{t('nav.businessAreas')}</Link></li>
              <li><Link to="/news" className="hover:text-white transition-colors">{t('nav.news')}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t('nav.contact')}</Link></li>
              <li><Link to="/policy" className="hover:text-white transition-colors">{t('footer.privacyPolicies')}</Link></li>
            </ul>
          </div>

          {/* Business Areas */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">{t('footer.businessSectors')}</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">{t('category.mining')}</li>
              <li className="hover:text-white transition-colors cursor-pointer">{t('category.agriculture')}</li>
              <li className="hover:text-white transition-colors cursor-pointer">{t('category.infrastructure')}</li>
              <li className="hover:text-white transition-colors cursor-pointer">{t('category.energy')}</li>
              <li className="hover:text-white transition-colors cursor-pointer">{t('business.telecom')}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">{t('footer.contactUs')}</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">{t('contact.phone')}</p>
                  <p>{mockData.companyInfo.contact.phone}</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">{t('footer.email')}</p>
                  <p>{mockData.companyInfo.contact.email}</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">{t('contact.location')}</p>
                  <p>{mockData.companyInfo.contact.address}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-gray-800 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-400 text-sm">
          <p>© 2024 {mockData.companyInfo.name}. {t('footer.allRights')}</p>
          <p>{t('footer.excellence')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
